module.exports = __webpack_public_path__ + "img/0314.2e6d8087.jpg";